<template lang="pug">
  .panel-page-white
    StoreFeedActivityModal(
      :show="activityDetail > -1"
      :transaction-id="activityDetail"
      @closeDetail="activityDetail = -1"
    )
    Modal(:show="oldSession" :modal-style="{height: '12rem'}")
      template(slot="header")
        h2 Session about to Expire
      template(slot="body")
        .body-1 Your session will expire. Do you want to extend it by an hour?
      template(slot="buttons")
        button.btn.btn-primary(@click.prevent="extendSession") Yes, Extend
        button.btn.btn-light.no-button(@click.prevent="endSession") No
    .panel-white.mx-auto
      ICEAlert
      audio#beep-boop(:src="beep"
                      @ended="beeping = false")
      PageHeader Live Store Feed
      h5 Store feeds will remain active for one hour from time of creation or until the feed is manually ended.
      AlertPanel.mb-5(v-model="willAlert")
      StoreFeedPanel.mb-5(v-for="storeId of $store.state.storesWatched"
                          :store-id="storeId"
                          :key="storeId"
                          @newData="playBeep"
                          @showTransaction="activityDetail = $event")
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AlertPanel from '@/components/AlertPanel'
import StoreFeedPanel from '@/components/StoreFeedPanel'
import StoreFeedActivityModal from '@/components/StoreFeedActivityModal'
import Modal from '@/components/Modal'
import beep from '@/assets/media/notify.mp3'

export default {
  name: 'StoreFeed',
  data: function() {
    return {
      willAlert: false,
      beep: beep,
      beeping: false,
      oldSession: false,
      sessionTicker: null,
      sessionTimeout: null,
      sessionStart: new Date(),
      activityDetail: -1,
    }
  },
  methods: {
    playBeep: function() {
      if (this.beeping || !this.willAlert) {
        return
      }
      this.beeping = true
      document.getElementById('beep-boop').play()
    },
    resetSession() {
      if (this.sessionTicker) window.clearInterval(this.sessionTicker)
      if (this.sessionTimeout) window.clearTimeout(this.sessionTimeout)
      this.sessionStart = new Date()
      this.oldSession = false
      this.sessionTicker = null
      this.sessionTimeout = null
    },
    startSession() {
      this.sessionTicker = window.setInterval(
        () => this.checkSession(),
        60 * 1000,
      )
    },
    extendSession: function() {
      this.resetSession()
      this.startSession()
    },
    endSession: function() {
      this.$store.state.storesWatched = []
      this.resetSession()
    },
    checkSession: function() {
      let now = new Date()
      // After 50 minutes, show the prompt to extend the session.
      this.oldSession = now - this.sessionStart > 50 * 60 * 1000
      if (this.oldSession) {
        window.clearInterval(this.sessionTicker)
        this.sessionTimeout = window.setTimeout(
          () => this.endSession(),
          10 * 60 * 1000,
        )
      }
    },
  },
  mounted: function() {
    this.resetSession()
    this.startSession()
    scrollTo(0, 0)
  },
  beforeDestroy: function() {
    this.resetSession()
  },
  beforeRouteLeave(_to, _from, next) {
    this.resetSession()
    next()
  },
  components: {
    PageHeader,
    AlertPanel,
    StoreFeedPanel,
    Modal,
    StoreFeedActivityModal,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 80%;

  @media (max-width: $bp-lg) {
    width: 100%;
  }
}

.no-button {
  width: 5rem;
}
</style>
